import React from "react";
import { VisionIcon, MissionIcon, TeamMemberIcon } from "../icons";

// Import team member images
import evelyn from "../images/people/EvelynCarrizo.png";
import bastian from "../images/people/BastianPillanchin.png";
import tomas from "../images/people/TomasCastillo.png";
import cecilia from "../images/people/CeciliaSepulveda.png";
import raul from "../images/people/RaulCerda.png";
import camila from "../images/people/CamilaSanchez.png";

const Neurocentro = () => {
  // Team members data
  const teamMembers = [
    {
      name: "Dr. Raúl Cerda",
      position: "Director Médico / Neurología / Neurocirugía",
      delay: ".5s",
      image: raul,
    },
    {
      name: "Dra. Camila Sánchez",
      position: "Jefa de Hospital / Neurología",
      delay: ".5s",
      image: camila,
    },
    {
      name: "Dra. Cecilia Sepúlveda",
      position: "Neurología / Neurocirugía",
      delay: ".6s",
      image: cecilia,
    },
    // {
    //   name: "Dra. Catalina Montero",
    //   position: "Neurología",
    //   delay: ".6s",
    // },
    {
      name: "Tomás Castillo",
      position: "Jefe Técnico Veterinario",
      delay: ".5s",
      image: tomas,
    },
    // {
    //   name: "Paulina Cortés",
    //   position: "Técnico Veterinario",
    //   delay: ".5s",
    // },
    {
      name: "Bastián Pillanchin",
      position: "Técnico Veterinario",
      delay: ".3s",
      image: bastian,
    },
    {
      name: "Evelyn Carrizo",
      position: "Administradora",
      delay: ".2s",
      image: evelyn,
    },
    // {
    //   name: "Paula Retamal",
    //   position: "Administrativo / Recepción",
    //   delay: ".3s",
    // },
    // {
    //   name: "Katherine Araya",
    //   position: "Recepción",
    //   delay: ".3s",
    // },
  ];

  return (
    <>
      {/* Vision and Mission Section */}
      <section
        id="mision-vision"
        className="relative z-10 pt-[110px] pb-[110px]"
      >
        <div className="container">
          <div
            className="wow fadeInUp mx-auto mb-14 max-w-[690px] text-center"
            data-wow-delay=".2s"
          >
            <h2 className="mb-4 text-3xl font-bold text-black dark:text-white sm:text-4xl md:text-[44px] md:leading-tight">
              Visión y Misión
            </h2>
          </div>

          <div className="flex flex-wrap -mx-4">
            <div className="w-full px-4 lg:w-1/2">
              <div className="wow fadeInUp" data-wow-delay=".3s">
                <div className="mb-8 flex h-[70px] w-[70px] items-center justify-center rounded-2xl bg-primary">
                  <MissionIcon className="w-9 h-9 text-white" />
                </div>
                <h3 className="mb-4 text-2xl font-bold text-black dark:text-white sm:text-3xl">
                  Nuestra Misión
                </h3>
                <p className="text-base text-body leading-relaxed">
                  Entregar atención neurológica veterinaria especializada,
                  precisa y confiable, mediante un equipo experto y tecnología
                  avanzada, mejorando la calidad de vida de perros y gatos con
                  enfermedades del sistema nervioso.
                </p>
              </div>
            </div>
            <div className="w-full px-4 lg:w-1/2">
              <div className="wow fadeInUp mb-12 lg:mb-0" data-wow-delay=".2s">
                <div className="mb-8 flex h-[70px] w-[70px] items-center justify-center rounded-2xl bg-primary">
                  <VisionIcon className="w-9 h-9 text-white" />
                </div>
                <h3 className="mb-4 text-2xl font-bold text-black dark:text-white sm:text-3xl">
                  Nuestra Visión
                </h3>
                <p className="text-base text-body leading-relaxed">
                  Ser un centro de referencia líder en neurología veterinaria en
                  Chile y el mundo, reconocido por la excelencia médica, la
                  innovación continua y una formación profesional de alto nivel.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section id="equipo" className="relative z-10 pt-[110px] pb-[110px]">
        <div className="container">
          <div
            className="wow fadeInUp mx-auto mb-14 max-w-[690px] text-center lg:mb-[70px]"
            data-wow-delay=".2s"
          >
            <h2 className="mb-4 text-3xl font-bold text-black dark:text-white sm:text-4xl md:text-[44px] md:leading-tight">
              Nuestro Equipo Especializado
            </h2>
            <p className="text-base text-body">
              Contamos con profesionales altamente capacitados y dedicados al
              cuidado de tu mascota.
            </p>
          </div>

          <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
            {teamMembers.map((member) => (
              <div
                key={member.name}
                className="wow fadeInUp group"
                data-wow-delay={member.delay}
              >
                <div className="relative overflow-hidden rounded-2xl mb-6">
                  <div className="aspect-square from-primary/20 to-primary/5 flex items-center justify-center">
                    {member.image ? (
                      <img
                        src={member.image}
                        alt={member.name}
                        className="h-full object-cover"
                      />
                    ) : (
                      <TeamMemberIcon className="w-[120px] h-[120px]" />
                    )}
                  </div>
                </div>
                <div className="text-center">
                  <h3 className="mb-2 text-xl font-semibold text-black dark:text-white">
                    {member.name}
                  </h3>
                  <p className="mb-3 text-base text-primary font-medium">
                    {member.position}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Neurocentro;
